export default __webpack_public_path__ + "static/media/DavidArnold.44a1628d.png";